// extracted by mini-css-extract-plugin
export default {"infoValue":"JamCommonHeader_infoValue__aYfUZ"};